import React from "react";

const Terrible = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="77"
      height="77"
      viewBox="0 0 77 77"
      fill="none"
    >
      <path
        d="M38.5 77C59.763 77 77 59.763 77 38.5C77 17.237 59.763 0 38.5 0C17.237 0 0 17.237 0 38.5C0 59.763 17.237 77 38.5 77Z"
        fill="#FBC926"
      />
      <path
        d="M33.9004 72.6984C24.8004 72.6984 16.5004 69.5984 9.90039 64.2984C16.9004 72.0984 27.1004 76.9984 38.4004 76.9984C59.6004 76.9984 76.9004 59.7984 76.9004 38.4984C76.9004 26.2984 71.2004 15.4984 62.4004 8.39844C68.6004 15.1984 72.3004 24.2984 72.3004 34.1984C72.4004 55.3984 55.2004 72.6984 33.9004 72.6984Z"
        fill="#F4BF11"
      />
      <path
        d="M30.7001 53.3016C30.5001 53.3016 30.3001 53.3016 30.1001 53.1016C29.5001 52.8016 29.2001 52.0016 29.6001 51.4016C31.4001 48.1016 34.8001 46.1016 38.5001 46.1016C42.2001 46.1016 45.6001 48.1016 47.4001 51.4016C47.7001 52.0016 47.5001 52.8016 46.9001 53.1016C46.3001 53.4016 45.5001 53.2016 45.2001 52.6016C43.9001 50.2016 41.3001 48.6016 38.6001 48.6016C35.8001 48.6016 33.3001 50.1016 32.0001 52.6016C31.6001 53.0016 31.1001 53.3016 30.7001 53.3016Z"
        fill="#332F2E"
      />
      <path
        d="M18.7997 39.3978C18.2997 39.3978 17.8997 39.0978 17.6997 38.6978C17.3997 38.0978 17.5997 37.2978 18.1997 36.9978L22.6997 34.6978L18.1997 32.3978C17.5997 32.0978 17.2997 31.2978 17.6997 30.6978C17.9997 30.0978 18.7997 29.7978 19.3997 30.1978L25.9997 33.5978C26.3997 33.7978 26.6997 34.2978 26.6997 34.6978C26.6997 35.1978 26.3997 35.6978 25.9997 35.8978L19.3997 39.2978C19.1997 39.3978 18.9997 39.3978 18.7997 39.3978Z"
        fill="#332F2E"
      />
      <path
        d="M58.1008 39.4003C57.9008 39.4003 57.7008 39.4003 57.5008 39.3003L51.0008 35.9003C50.6008 35.7003 50.3008 35.2003 50.3008 34.8003C50.3008 34.3003 50.6008 33.8003 51.0008 33.6003L57.6008 30.2003C58.2008 29.9003 59.0008 30.1003 59.3008 30.7003C59.6008 31.3003 59.4008 32.1003 58.8008 32.4003L54.3008 34.7003L58.8008 37.0003C59.4008 37.3003 59.7008 38.1003 59.3008 38.7003C59.0008 39.2003 58.6008 39.4003 58.1008 39.4003Z"
        fill="#332F2E"
      />
    </svg>
  );
};

export default Terrible;
